"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlackConfigOutSerializer = void 0;
exports.SlackConfigOutSerializer = {
    _fromJsonObject(object) {
        return {};
    },
    _toJsonObject(self) {
        return {};
    },
};
//# sourceMappingURL=slackConfigOut.js.map